<template>
  <div class="Child">
    <vxe-toolbar>
      <template v-slot:buttons>
        <el-button type="primary" @click="getSelectEvent">获取选中</el-button>
        <el-button type="primary" @click="funcFilter()">查询</el-button>
      </template>
    </vxe-toolbar>

    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      height="500"
      :data="tableData"
    >
      <vxe-table-column type="radio" width="60" />
      <vxe-table-column>
        <vxe-table-column
          field="licenseNumber"
          title="车牌号"
          min-width="100"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.licenseNumber"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="roadTransportCertificateNumber"
          title="运输许可号"
          min-width="100"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.roadTransportCertificateNumber"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="loadWeight"
        title="车辆载重(kg)"
        min-width="100"
      />
      <vxe-table-column>
        <vxe-table-column
          field="driverName"
          title="实际承运人姓名"
          min-width="100"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.driverName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverPhone"
          title="实际承运人手机号"
          min-width="100"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.driverPhone"
            type="number"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
    </vxe-table>

    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <downloadData ref="downloadRef" />
  </div>
</template>

<script>
import { vehicle } from "@/api/transport";
export default {
  name: "Child",
  data() {
    return {
      loading: false,
      tableData: [],
      listQuery: {
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0,
        // authStatus: 3,
        driverPhone: "",
        driverName: "",
        loadWeight: "",
        roadTransportCertificateNumber: "",
        licenseNumber: "",
        branchCodeExt: "",
        authStatusExt: 3
      },
      selectRecords: []
    };
  },
  created() {
    this.designcar(this.listQuery.branchCodeExt);
  },
  methods: {
    designcar(branchCodeExt) {
      this.listQuery.branchCodeExt = branchCodeExt;
      vehicle(this.listQuery).then(response => {
        this.tableData = response.data.records;
        this.listQuery.total = response.data.total;
      });
    },
    // 查询
    funcFilter() {
      this.listQuery.pageNum = 1;
      this.designcar(this.listQuery.branchCodeExt);
    },
    getSelectEvent() {
      this.selectRecords = this.$refs.xTable.getRadioRecord();
      this.$emit("event2", this.selectRecords);
    },

    // 取消选中
    clearRadioRowEevnt() {
      this.selectRow = null;
      this.$refs.xTable1.clearRadioRow();
    },
    // 选中事件
    radioChangeEvent({ row }) {
      this.selectRow = row;
    },
    // 分页handle
    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.pageNum = currentPage;
      this.listQuery.pageSize = pageSize;
      this.designcar(this.listQuery.branchCodeExt);
    }
  }
};
</script>

<style></style>
